import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import Media from "@qlik/qlik/src/components/Media";
import {
    filterValidCta,
    renderSanitizedHtmlContent,
    getResourceInternalLinkCta,
} from "@qlik/qlik/src/lib/util/helpers";
import {
    RESOURCE_TERM_RESOURCE_TYPE,
    resourceCategoryFieldMapping,
} from "@qlik/qlik/src/lib/constants/resource-constants";

import * as styles from "./styles.module.css";

/**
 * React component for displaying a single CTA resource card.
 * @param {Object} props - The props for the component.
 * @param {Object} props.resource - The resource data to be displayed.
 * @returns {JSX.Element} - The JSX element representing the single CTA resource card.
 */
const SingleCtaResourceCard = ({ resource }) => {
    const getCardImage = () => resource?.featuredImage ?? resource?.image;
    const isImageAvailable = resource?.featuredImage || resource?.image;

    // Get CTA from resource
    let ctaList = filterValidCta(resource?.cta ?? []);
    ctaList = getResourceInternalLinkCta(resource, ctaList);
    let cta = ctaList?.[0] ?? false;

    // Restructure the query params object to match the format expected by the Cta component
    if (cta?.queryParams) {
        cta = { ...cta, queryParams: { queryParams: cta.queryParams } };
    }

    return (
        <Cta
            data={cta}
            className={`${styles.resourceMediaCard} min-h-full min-w-full relative group border border-stone/50 bg-white rounded p-3 lg:pb-5 lg:pt-4.5 lg:px-4.75 flex flex-col hover:no-underline group/resource-card lg:hover:shadow-lg  transition-shadow duration-300  after:hidden`}
        >
            <div>
                {isImageAvailable && (
                    <div className="h-29 overflow-hidden mb-5 resource-media-card">
                        <Media
                            media={getCardImage()}
                            className="w-full h-full object-cover lg:group-hover/resource-card:scale-110 transition-transform duration-300"
                        />
                    </div>
                )}
            </div>
            <div>
                <div>
                    <div className="tag-1 uppercase text-sm">
                        {resource?.[resourceCategoryFieldMapping[RESOURCE_TERM_RESOURCE_TYPE]]?.[0]?.title}
                    </div>
                </div>
            </div>
            <div>
                {resource?.title && (
                    <p
                        className="line-clamp-3 mt-2.5 body-small text-gray mb-7.5"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(resource?.title) }}
                    />
                )}
            </div>
            <div className={`${styles.ctaSections} mt-auto flex`}>
                {cta && (
                    <Cta
                        key={cta.id}
                        data={{ textOnly: true, text: cta.text }}
                        className="green-link lg:group-hover/resource-card:text-dark-green lg:group-hover/resource-card:after:arrow-green-dark lg:group-hover/resource-card:after:translate-x-0.75  highlight-transparent"
                    />
                )}
            </div>
        </Cta>
    );
};

export default SingleCtaResourceCard;
